const members = () => {
	let totalPages;
	let activePage = 1;
	let paginationUsed = false;
	const membersListWrapper = document.querySelector('[data-js="membersList"]');
	const membersListPaginationWrapper = document.querySelector('[data-js="membersListPagination"]');
	let defaultURL;

	const memberTemplate = (logo, city, title, description, website) => `<figure class="members__member">
	<span>
		${logo}
	</span>
	<figcaption>
		<header>
			<h4>${title}</h4>
			<p>${city}</p>
		</header>
		<p>${description}</p>
		<footer>
			<a href="${website}" class="link" target="_blank">Go to website</a>
		</footer>
	</figcaption>
</figure>`;

	const paginationTemplate = (current, total, pageList) => `<a href="#${
		current > 1 ? current - 1 : 1
	}" aria-label="previous">
	<span class="is-hidden">previous</span></a>
	<span>${current} z ${total}</span>
	${pageList}
	<a href="#${current < total ? current + 1 : total}" aria-label="next"><span class="is-hidden">next</span></a>`;

	async function getData(address, perPage = '6', startPage = '1') {
		const url = new URL(address);
		if (perPage) url.searchParams.append('per_page', perPage);
		if (startPage) url.searchParams.append('page', startPage);
		const response = await fetch(url, {
			// credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				// Authorization: `Basic ${btoa(`test:123beta`)}`,
			},
		});
		return response;
	}

	const createMembersList = (data) => {
		membersListWrapper.innerHTML = '';
		data.forEach((member) => {
			const { logo, city, title, description, website } = member;
			membersListWrapper.insertAdjacentHTML(
				'afterbegin',
				memberTemplate(logo, city, title.rendered, description, website),
			);
		});
	};

	const createPagination = () => {
		membersListPaginationWrapper.innerHTML = '';
		const pages = (pagesValue) => {
			const counter = pagesValue;
			let list = '';
			for (let index = 0; index < counter; index += 1) {
				list += `<a href="#${index + 1}" ${index + 1 === activePage ? `class="is-active"` : null}>${index + 1}</a>`;
			}
			return list;
		};
		membersListPaginationWrapper.insertAdjacentHTML(
			'afterbegin',
			paginationTemplate(activePage, totalPages, pages(parseInt(totalPages, 10))),
		);
	};

	const createPaginationEvents = () => {
		document.querySelectorAll('[data-js="membersListPagination"] a').forEach((link) => {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				const pageNumber = parseInt(event.target.getAttribute('href').slice(1), 10);
				if (pageNumber !== activePage) {
					activePage = pageNumber;
					getData(defaultURL, undefined, pageNumber)
						.then((response) => response.json())
						.then((data) => {
							createMembersList(data);
							createPagination();
						})
						.then(() => {
							createPaginationEvents();
						})
						.then(() => {
							if (paginationUsed) {
								document.querySelector('#members').scrollIntoView();
							}
						});
				}
				paginationUsed = true;
			});
		});
	};

	if (document.querySelector('[data-js="membersList"]')) {
		defaultURL = membersListWrapper.dataset.handler;
		// get first page
		getData(defaultURL, undefined, '1')
			.then((response) => {
				totalPages = parseFloat(response.headers.get('X-WP-TotalPages'));

				return response.json();
			})
			.then((data) => {
				createMembersList(data);
				createPagination();
			})
			.then(() => {
				createPaginationEvents();
			});
	}
};

export default members;
